import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2536401a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "avatar-dropdown"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "user-name"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("em", {
  class: "el-icon-arrow-down el-icon--right"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个人中心", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_remix_icon = _resolveComponent("remix-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createBlock(_component_el_dropdown, {
    onCommand: $options.handleCommand
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "navigateToPersonalCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-user",
          class: "el-dropdown-menu__item-icon"
        }), _hoisted_5]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        command: "logout",
        divided: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_remix_icon, {
          icon: "fas fa-sign-out-alt",
          class: "el-dropdown-menu__item-icon"
        }), _hoisted_6]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
      class: "user-avatar",
      src: $options.avatar,
      alt: ""
    }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString($options.account) + " ", 1), _hoisted_4])])]),
    _: 1
  }, 8, ["onCommand"]);
}